<template>
  <div>
    <nav-bar />
    <router-view />
  </div>
</template>

<script>
import NavBar from '@/views/layouts/components/NavBar.vue'

export default {
  name: 'AdminLayout',
  data () {
    return { }
  },
  components: {
    NavBar
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/AppLayout.vue